import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../../common/ModalTrigger';
import EmployerSignupForm from '../EmployerSignupForm';
import { analyticsTrack } from '../../../analyticsUtils';
import './Wall.scss';

class Wall extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
    this.handleEventsTracking = this.handleEventsTracking.bind(this);
  }

  handleEventsTracking() {
    const { location } = this.props;
    analyticsTrack('Clicked on get started', { location });
    analyticsTrack('Opened registration modal', { location });
  }

  render() {
    const {
      csrfToken, signInUrl, googleOmniauthUrl,
      msOmniauthUrl, consultantFirstName, location,
      inviterId, projectResourceId,
    } = this.props;

    return [
      <div className="blur-text" />,
      <div className="registration-wall">
        <h3>
          {`Ready to review ${consultantFirstName}’s full proposal & hourly rate?`}
        </h3>
        <ModalTrigger
          triggerText="Get Started"
          buttonStyles="primary"
          dialogClassName="style-guide registration-modal"
          closeAfterSubmit
          idKey="employer-registration-modal"
          showFooter={false}
          onClick={this.handleEventsTracking}
        >
          <div className="employer-registration-modal">
            <h1 className="hero-header">
              Switch to the simplest way of hiring
            </h1>
            <EmployerSignupForm
              csrfToken={csrfToken}
              submitButtonText="Sign Up"
              pageLocation="proposal"
              signInUrl={signInUrl}
              googleOmniauthUrl={googleOmniauthUrl}
              msOmniauthUrl={msOmniauthUrl}
              location={location}
              inviterId={inviterId}
              projectResourceId={projectResourceId}
            />
          </div>
        </ModalTrigger>
      </div>,
    ];
  }
}

Wall.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
  googleOmniauthUrl: PropTypes.string.isRequired,
  msOmniauthUrl: PropTypes.string.isRequired,
  consultantFirstName: PropTypes.string.isRequired,
  location: PropTypes.string,
  inviterId: PropTypes.string,
  projectResourceId: PropTypes.string,
};

Wall.defaultProps = {
  location: 'Proposal share - employers',
  inviterId: null,
  projectResourceId: null,
};
export default Wall;
